import React from 'react';
import { Box, Inscription, RoundCloseIcon, WarningLabel } from '@common-fe/common-fe';

import { PaymentMethodVerificationStatus } from '@/modules/ReimburseMe/types/payment.types';

interface Props {
  status?: PaymentMethodVerificationStatus;
  withoutButton?: boolean;
  isHighlighted?: boolean;
  highlightedTop?: boolean;
}

export const PlaidDirectDepositBanner: React.FC<Props> = ({
  status,
  withoutButton,
  isHighlighted,
  highlightedTop,
}) => {
  if (!status) {
    return null;
  }

  if (status === PaymentMethodVerificationStatus.PENDING || status === PaymentMethodVerificationStatus.PENDING_MANUAL) {
    return (
      <Box
        data-testid="PlaidDirectDepositBanner"
        pad={{
          horizontal: 'spacing24',
          ...(highlightedTop ? { bottom: 'spacing16' } : { vertical: 'spacing16' })
        }}
        background={{ color: 'warningContainer' }}
        border={{ size: isHighlighted ? '2px' : '1px', color: isHighlighted ? 'warning' : 'warningBorder' }}
        round="fieldRound"
        direction="row"
        justify="between"
        align="center"
      >
        <Box>
          {highlightedTop && (
            <Box
              height="2px"
              width="100%"
              background={{ color: 'warning'}}
              margin={{ top: '-1px', bottom: 'spacing16' }}
            />
          )}
          <Inscription weight="bold" margin={{ bottom: 'spacing8' }} color="textBody">
            <WarningLabel>
              Your account verification is in progress.
            </WarningLabel>
          </Inscription>

          <Box>
            <Inscription
              margin={{ bottom: 'spacing8' }}
              color="textBody"
              size="14px"
            >
              {'A small deposit will be posted to your account within one to two business days. '}
              {status === PaymentMethodVerificationStatus.PENDING
                ? 'Once posted, your account will automatically verified. No further action is needed.'
                : 'Once posted, you will need to provide additional details to verify your account.'}
            </Inscription>
          </Box>
        </Box>
      </Box>
    );
  }

  if (status === PaymentMethodVerificationStatus.VERIFICATION_FAILED || status === PaymentMethodVerificationStatus.EXPIRED) {
    return (
      <>
        {highlightedTop && (
          <Box
            height="2px"
            width="calc(100% - 48px)"
            background={{ color: 'danger'}}
            margin={{ bottom: '-2px', horizontal: 'spacing24' }}
            style={{ zIndex: 1 }}
          />
        )}
        <Box
          data-testid="PlaidDirectDepositBanner"
          pad={{
            horizontal: 'spacing24',
            vertical: 'spacing16'
          }}
          background={{ color: 'dangerContainer' }}
          border={{ size: isHighlighted ? '2px' : '1px', color: isHighlighted ? 'danger' : 'dangerBorder' }}
          round="fieldRound"
          direction={withoutButton ? 'column' : 'row'}
          justify="between"
          align={withoutButton ? 'start' : 'center'}
        >
          <Box>
            <Box
              direction="row"
              align="center"
              margin={{ bottom: 'spacing8' }}
              gap="spacing8"
            >
              <RoundCloseIcon color="danger" />
              <Inscription weight="bold" color="textBody">
                Your bank account could not be verified.
              </Inscription>
            </Box>

            <Box>
              <Inscription
                margin={{ bottom: 'spacing8' }}
                color="textBody"
                size="14px"
              >
                Update banking account information to try again or add a new bank account.
              </Inscription>
            </Box>
          </Box>
        </Box>
      </>
    );
  }

  return null;
};
